
import { LoginComponent } from './login.component';

export const LoginStates : Array<any> = [
  {
    component: LoginComponent,
    name     : 'app.login',
    url      : '/login'
  }
];
